// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { HolderServiceRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Holder';
import { CreateEvent } from '@daml/ledger';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useRequestHolderService: () => UseMutationResult<
  CreateEvent<HolderServiceRequest>,
  string,
  {
    provider: string;
    operator: string;
    party: string;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['requestRegistryHolderService', ledgerApi],
    mutationFn: async ({ provider, operator, party }) => {
      return ledgerApi.requestRegistryHolderService(operator, provider, party);
    },
  });
};

export default useRequestHolderService;
